import { render, staticRenderFns } from "./confBtn.vue?vue&type=template&id=536b0fe2&scoped=true&lang=pug"
import script from "./confBtn.vue?vue&type=script&lang=js"
export * from "./confBtn.vue?vue&type=script&lang=js"
import style0 from "./confBtn.vue?vue&type=style&index=0&id=536b0fe2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b0fe2",
  null
  
)

export default component.exports